import { useState } from "react";
import { useLikeArticle } from "../../../domains/user/hooks/useLikeArticle";
import { AnalyticsItemList } from "../../../tools/analytics/analytics.types";
import { useSaveArticle } from "../../../domains/user/hooks/useSaveArticle";
import { useShareArticle } from "../../../domains/user/hooks/useShareArticle";
import type { Api } from "../../../services/api";
import type { ArticleDetail } from "./useArticleData";

type ArticleListItem =
  Api["get"]["/webapp/public/articles"]["output"]["body"]["docs"][number];
type ArticleInteractionModel = ArticleDetail | ArticleListItem;

export function useArticleInteractions(
  article: ArticleInteractionModel | null
) {
  const [isWaitingActionResult, setWaitingActionResult] = useState(false);
  const { isLiked, toggleLike } = useLikeArticle(
    article,
    AnalyticsItemList.ARTICLE_PAGE
  );
  const { isSaved, toggleSaveToPlaylists } = useSaveArticle(
    article,
    AnalyticsItemList.ARTICLE_PAGE
  );
  const { triggerShare: shareArticle } = useShareArticle(
    AnalyticsItemList.ARTICLE_PAGE
  );

  async function toggleLikeSafe() {
    if (isWaitingActionResult || article === null) return; // Prevent double action
    setWaitingActionResult(true);
    await toggleLike(article);
    setWaitingActionResult(false);
  }

  return {
    isLiked,
    isSaved,
    toggleLikeSafe,
    toggleSaveToPlaylists,
    shareArticle,
  };
}
